import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CustomBuilderService } from '../../../_services/custom-bulider.service';
import { ObjectFilterPipe } from '../../../_pipes/object-filter.pipe';
import { CategoryService } from '../../../_services/category.service';
import { KioskCategoryService } from '../../../_services/kiosk-category.service';
import { FoodToGoService } from '../../../_services/food-to-go.service';
import { TreeNode, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-single-builder-details',
  templateUrl: './single-builder-details.component.html',
  styleUrls: ['./single-builder-details.component.css'],
})
export class SingleCustomBuilderDetailsComponent implements OnInit {
  tabitems: any = [];
  stageitems: any = [];
  customBuilderId: any;
  selectedCustomBuilder: any;
  builderDetailsForm: FormGroup;

  role: any;
  routeRole: any;
  currentStage;

  addStageForm: FormGroup;
  addStageModal = false;

  displayCategories: TreeNode[] = [];
  categories: any[] = [];
  selectedCategory = { label: 'No Category Selected', id: null, name: null, data: { id: null } };
  changeCategoryModal = false;

  displayKioskCategories: TreeNode[] = [];
  kioskCategories: any[] = [];
  selectedKioskCategory = { label: 'No Kiosk Category Selected', id: null, data: { id: null } };
  changeKioskCategoryModal = false;

  displayFoodToGoCategories: TreeNode[] = [];
  foodToGoCategories: any[] = [];
  selectedFoodToGoCategory = { label: 'No Category Selected', id: null, data: { id: null } };
  changeFoodToGoCategoryModal = false;

  cookieStore: any;
  storeId: any;

  constructor(
    fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoadingBarService,
    public notificationService: NotificationService,
    public globals: Globals,
    public _customBuilderService: CustomBuilderService,
    public objectFilter: ObjectFilterPipe,
    public _categoryService: CategoryService,
    public _kioskCategoryService: KioskCategoryService,
    public _foodToGoService: FoodToGoService,
    public cookieService: CookieService,
    public router: Router,
    public confirmationService: ConfirmationService
  ) {
    // Get builder id from params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.customBuilderId = params.id;
    });

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      {
        path: '/' + this.routeRole + '/custom-builders/',
        title: 'All Builders',
        class: 'back-link',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/details',
        title: 'Details',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/steps',
        title: 'Steps',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/images',
        title: 'Images',
      },
    ];

    this.builderDetailsForm = fb.group({
      description: new FormControl(),
      basePrice: new FormControl(),
      itemCategory: new FormControl(),
      itemCategoryKiosk: new FormControl(),
      foodToGoCategory: new FormControl(),
      name: new FormControl(),
    });
  }

  ngOnInit() {
    this.getCustomBuilder(this.customBuilderId);
    this.getAllCategories();
    this.getAllKioskCategories();
    this.getAllFoodToGoCategories();
  }

  // Get Custom Builder by id
  public getCustomBuilder(id) {
    this._customBuilderService.getBuilderById(id).subscribe((data: any) => {
      // console.log('Custom Builder - ', data);
      this.selectedCustomBuilder = data;
      this.assignFormValues();
    });
  }

  public assignFormValues() {
    this.builderDetailsForm.patchValue({
      name: this.selectedCustomBuilder.name,
      description: this.selectedCustomBuilder.description,
      basePrice: this.selectedCustomBuilder.basePrice,
    });
    // console.log('selectedCustomBuilder', this.selectedCustomBuilder);
    // Account for nullable itemCategory
    if (this.selectedCustomBuilder.itemCategory !== null) {
      this.selectedCategory.label = this.selectedCustomBuilder.itemCategory.name;
      this.selectedCategory.id = this.selectedCustomBuilder.itemCategory.id;
      this.selectedCategory.data = this.selectedCustomBuilder.itemCategory;
      this.builderDetailsForm.patchValue({
        itemCategory: this.selectedCustomBuilder.itemCategory.name,
      });
    }
    // Account for nullable itemCategoryKiosk
    if (this.selectedCustomBuilder.itemCategoryKiosk !== null) {
      this.selectedKioskCategory.label = this.selectedCustomBuilder.itemCategoryKiosk.name;
      this.selectedKioskCategory.id = this.selectedCustomBuilder.itemCategoryKiosk.id;
      this.selectedKioskCategory.data = this.selectedCustomBuilder.itemCategoryKiosk;
      this.builderDetailsForm.patchValue({
        itemCategoryKiosk: this.selectedCustomBuilder.itemCategoryKiosk.name,
      });
    }

    // Account for nullable foodToGoItemCategory
    if (this.selectedCustomBuilder.foodToGoItemCategory !== null) {
      this.selectedKioskCategory.label = this.selectedCustomBuilder.foodToGoItemCategory.name;
      this.selectedKioskCategory.id = this.selectedCustomBuilder.foodToGoItemCategory.id;
      this.selectedKioskCategory.data = this.selectedCustomBuilder.foodToGoItemCategory;
      this.builderDetailsForm.patchValue({
        foodToGoCategory: this.selectedCustomBuilder.foodToGoItemCategory.name,
      });
    }
  }

  // Submit Biulder Form Changes
  public onBuilderDetailsFormSubmit() {
    const values = this.builderDetailsForm.value;
    const body = {
      basePrice: values.basePrice,
      description: values.description,
      itemCategoryId: this.selectedCategory.id,
      // itemCategoryKioskId: this.selectedKioskCategory.id,
      foodToGoCategoryId: this.selectedFoodToGoCategory.id,
      name: values.name,
    };

    this._customBuilderService.editBuilder(this.customBuilderId, body).subscribe((data: any) => {
      // console.log(data);
      this.getCustomBuilder(this.customBuilderId);
      this.notificationService.notify('success', 'Custom Builder Updated', 'Custom Builder has successfully been updated', 'top', 'right');
    });
  }

  // CHANGING CATEGORIES FUNCTIONS
  public getAllCategories() {
    this.displayCategories = [];
    this._categoryService.getItemCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      this.categories = data;
      this.filterRootItemCategories(null);
    });
  }

  public getAllKioskCategories() {
    this.displayKioskCategories = [];
    this._kioskCategoryService.getItemKioskCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      this.kioskCategories = data;
      this.filterRootItemKioskCategories(null);
    });
  }

  public getAllFoodToGoCategories() {
    this.displayFoodToGoCategories = [];
    this._foodToGoService.getItemCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      this.foodToGoCategories = data;
      this.filterRootItemFoodToGoCategories(null);
    });
  }

  public populateTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayCategories.push(treeNodeObject);
    });
  }

  public populateKioskTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayKioskCategories.push(treeNodeObject);
    });
  }

  public populateFoodToGoTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentFoodToGoItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayFoodToGoCategories.push(treeNodeObject);
    });
  }

  public filterRootItemCategories(categoryId) {
    const catId = categoryId;
    const filteredCats = this.objectFilter.transform(this.categories, 'parentItemCategoryId', catId);
    this.populateTreeMenu(filteredCats);
  }

  public filterRootItemKioskCategories(kioskCategoryId) {
    const catId = kioskCategoryId;
    const filteredCats = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', catId);
    this.populateKioskTreeMenu(filteredCats);
  }

  public filterRootItemFoodToGoCategories(foodToGoCategoryId) {
    const catId = foodToGoCategoryId;
    const filteredCats = this.objectFilter.transform(this.foodToGoCategories, 'parentFoodToGoItemCategoryId', catId);

    this.populateFoodToGoTreeMenu(filteredCats);
  }

  public loadNode(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(this.categories, 'parentItemCategoryId', parentId);
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public loadNodeKiosk(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(this.kioskCategories, 'parentItemCategoryId', parentId);
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public loadNodeFoodToGo(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(this.foodToGoCategories, 'parentFoodToGoItemCategoryId', parentId);
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentFoodToGoItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public nodeSelect(event) {
    this.selectedCategory.label = event.node.data.name;
    this.selectedCategory.id = event.node.data.id;
    this.selectedCategory.data = event.node.data;
  }

  public nodeSelectKiosk(event) {
    this.selectedKioskCategory.label = event.node.data.name;
    this.selectedKioskCategory.id = event.node.data.id;
    this.selectedKioskCategory.data = event.node.data;
  }

  public nodeSelectFoodToGo(event) {
    this.selectedFoodToGoCategory.label = event.node.data.name;
    this.selectedFoodToGoCategory.id = event.node.data.id;
    this.selectedFoodToGoCategory.data = event.node.data;
  }

  public openChangeCategoryModal() {
    this.changeCategoryModal = !this.changeCategoryModal;
  }

  public openChangeFoodToGoCategoryModal() {
    this.changeFoodToGoCategoryModal = !this.changeFoodToGoCategoryModal;
  }

  public openChangeKioskCategoryModal() {
    this.changeKioskCategoryModal = !this.changeKioskCategoryModal;
  }

  public confirmCategoryChange() {
    this.builderDetailsForm.patchValue({
      categoryId: this.selectedCategory.id,
      itemCategory: this.selectedCategory.label,
    });
    this.openChangeCategoryModal();
  }

  public confirmKioskCategoryChange() {
    this.builderDetailsForm.patchValue({
      kioskCategoryId: this.selectedKioskCategory.id,
      itemCategoryKiosk: this.selectedKioskCategory.label,
    });
    this.openChangeKioskCategoryModal();
  }

  public confirmFoodToGoCategoryChange() {
    this.builderDetailsForm.patchValue({
      foodToGoCategoryId: this.selectedFoodToGoCategory.id,
      foodToGoCategory: this.selectedFoodToGoCategory.label,
    });
    this.openChangeFoodToGoCategoryModal();
  }

  removeFoodToGoCategory() {
    this.builderDetailsForm.patchValue({
      foodToGoCategory: null,
    });
    this.selectedFoodToGoCategory = { label: 'No Category Selected', id: null, data: { id: null } };
  }

  removeCategory() {
    this.builderDetailsForm.patchValue({
      itemCategory: null,
    });
    this.selectedCategory = { label: 'No Category Selected', id: null, name: null, data: { id: null } };
  }

  public deleteBuilder(builder) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this builder?',
      accept: () => {
        this._customBuilderService.deleteBuilder(builder.id).subscribe((data: any) => {
          // console.log(data);
          this.notificationService.notify('success', 'Custom Builder Deleted', 'Custom Builder has successfully been deleted', 'top', 'right');
          this.router.navigate(['/' + this.routeRole + '/custom-builders']);
        });
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/custom-builders/single-builder/single-builder-details/single-builder-details.component.ts